import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const Gausss = () => (
  <QPhototModuleSubtopic
    title="Gauss divergence theorem "
    videos={[
      "https://www.youtube.com/embed/wzh4y2jAiyI"

    ]}
    takeaways={[]}
    questions={[
        {
            image:"/cal_80.png"
        },
        {
            image:"/cal_81.png"
        }
    ]}
    exampleVideos={[]}
  />
);

export default Gausss;
